import { render, staticRenderFns } from "./IconSafeHeart.vue?vue&type=template&id=ced3577a&"
import script from "./IconSafeHeart.vue?vue&type=script&lang=js&"
export * from "./IconSafeHeart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports